
/* eslint-disable arrow-body-style */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formikSubmitDisabled = (formik: any) => {
  const { isValid, isSubmitting } = formik;
  return (!isValid || isSubmitting);
};

export const typedKeys = <T>(object: T): (keyof T)[] => Object.keys(object) as (keyof T)[];
